export default __webpack_public_path__ + "static/media/play-at-home.4813771e.png";